<header id="goiMenua" class="barratop navbar" [ngClass]="{'menu-zabalduta':isExpanded, '':isExpanded}" *ngIf="user">
  <nav class="navbar navbar-expand-sm w-100 p-0">
    <h2><span >{{menuService.titulo}}</span></h2>
    <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse" [ngClass]="{ show: isExpanded }">
      <ul class="navbar-nav navbar-nav-user usermenu mt-2">

        <!--IDIOMA -->
        <li id="cidioma" class="dropdown selector-idioma">
          <span id="LidiomaActual" class="idioma-seleccionado"
            data-toggle="dropdown">{{ 'idiomaSeleccionado' | translate}}</span>
          <ul class="dropdown-menu">
            <li id="menuIdiomasES" class="">
              <a id="HLes" (click)="useLanguage('es')">ES</a>
            </li>
            <li id="menuIdiomasEU" class="">
              <a id="HLeu" (click)="useLanguage('eu')">EU</a>
            </li>
            <li id="menuIdiomasEN" class="">
              <a id="HLen" (click)="useLanguage('en')">EN</a>
            </li>
            <li id="menuIdiomasDE" class="">
              <a id="HLde" (click)="useLanguage('de')">DE</a>
            </li>
            <li id="menuIdiomasFR" class="">
              <a id="HLfr" (click)="useLanguage('fr')">FR</a>
            </li>
            <li id="menuIdiomasIT" class="">
              <a id="HLit" (click)="useLanguage('it')">IT</a>
            </li>
            <li id="menuIdiomasPT" class="">
              <a id="HLpt" (click)="useLanguage('pt')">PT</a>
            </li>
          </ul>
        </li>

        <!--TUTORIALES -->

        <li>
          <a id="HLtutoriales" title="Tutorial" class="tutoriales-nav" href="/Tutorial"> </a>
        </li>

        <!--MENÚ USUARIO -->

        <li class="dropdown">
          <a data-toggle="dropdown" class="nombre-usuario"><span class="circulo-usuario">A</span></a>

          <div class="dropdown-menu dropdown-usuario">
            <div class="inner-usuario-nombre-cont clearfix" [routerLink]="['/profile']">
              <span class="inner-usuario-circulo-usuario">A</span>
              <span id="Lnombre" class="inner-usuario-nombre"> {{ user.nombre }} {{ user.apellido1 }}</span>
            </div>

            <div class="clearfix">
              <div class="inner-usuario-tipo-cont">
                <span id="" class="inner-usuario-titulo">{{ 'usuarios.tipousuario' | translate}}</span>
                <span id="Ltipo" class="inner-usuario-tipo">{{ user.usuarioTipo }}</span>
              </div>

              <div class="inner-usuario-num-cont">
                <span id="" class="inner-usuario-titulo">ID:</span>
                <span id="Lnum" class="inner-usuario-num">{{ user.id }}</span>
              </div>
            </div>

            <div class="clearfix">
              <div class="clearfix"><span class="inner-usuario-titulo">Skin</span></div>
              <div class="inner-usuario-itxura-cont">
                <div (click)="temaArgia()" class="itxura-aldaketa-argia"
                  [ngClass]="{'aukeratuta':tema == 1, '':tema != 1}"></div>
              </div>
              <div class="inner-usuario-itxura-cont">
                <div (click)="temaIluna()" class="itxura-aldaketa-iluna"
                  [ngClass]="{'aukeratuta':tema == 2, '':tema != 2}"></div>
              </div>
            </div>

            <div class="cont-linea">
              <div class="inner-usuario-logout-cont">
                  <a (click)="logout()" class="btn btn-danger w-100 salir">{{ 'menu.cerrarsesion' | translate}}</a>
              </div>
            </div>
            
          </div>
        </li>

      </ul>
    </div>
  </nav>
</header>


<!-- Vertical navbar -->
<div id="ezkerMenua" class="barramenu" [ngClass]="{'menu-zabalduta':isExpanded, '':isExpanded}" *ngIf="user">

  <div class="logotipoa"></div>

  <div id="botonExpandir" (click)="expandir()" class="menu-zabalera-blokeatu"></div>


  <h3>{{ 'menu.principal' | translate}}</h3>

  <ul class="nav flex-column mb-0">
    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a [routerLink]="['/home']" class="nav-link ">
        {{ 'menu.inicio' | translate}}
      </a>
    </li>

  </ul>

  <h3>{{ 'patrocinadores.titulo' | translate}}</h3>

  <ul class="nav flex-column mb-0"  *ngIf="user.gestionUsuarios > 0">
    <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
      <a class="nav-link " [routerLink]="['/aplicaciones']">{{ 'patrocinadores.apps' | translate}}</a>
    </li>

    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link " [routerLink]="['/usuarios']">{{ 'usuarios.usuarios' | translate}}</a>
    </li>
  </ul>


  <h3 *ngIf="user.gestionUsuarios > 0">{{ 'usuarios.gestionusuarios' | translate}}</h3>

  <ul class="nav flex-column mb-0"  *ngIf="user.gestionUsuarios > 0">
    <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
      <a class="nav-link " [routerLink]="['/usuarios-tipos']">{{ 'usuarios.tiposusuario' | translate}}</a>
    </li>

    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link " [routerLink]="['/usuarios']">{{ 'usuarios.usuarios' | translate}}</a>
    </li>
  </ul>
</div>




<div class="contenedor body-content" [ngClass]="{'menu-zabalduta':isExpanded, '':isExpanded}">



  <!-- subnav router outlet -->
  <router-outlet name="subnav"></router-outlet>

  <!-- global alert -->
  <alert></alert>

  <!-- main router outlet -->
  <router-outlet></router-outlet>

</div>
